import { render, staticRenderFns } from "./productcoupon_management.vue?vue&type=template&id=3e93c734&"
import script from "./productcoupon_management.vue?vue&type=script&lang=js&"
export * from "./productcoupon_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports